import {
  GoabBlock,
  GoabCheckbox,
  GoabContainer,
  GoabFormItem,
  GoabInput,
  GoabRadioGroup,
  GoabRadioItem,
} from "@abgov/react-components";

import { PhoneNumberETransfer, BankAccountDetailsETransfer } from "./";
import { useGenerationForm } from "../../../../hooks";

export const ETransferPaymentInfo = () => {
  const {
    form,
    fieldValues,
    fieldErrors,
    fieldTouches,
    handleChange,
    handleBlur,
    handleETransferChange,
    isReady,
  } = useGenerationForm("PaymentInformation");

  // Early return if form not ready.
  if (!isReady) return null;

  const emailError = fieldTouches.email && fieldErrors.email;
  const confirmEmailError =
    fieldTouches.confirmEmail && fieldErrors.confirmEmail;

  return (
    <>
      <GoabContainer accent="filled">
        <h3>e-Transfer information</h3>
        <GoabBlock direction="column" gap="s">
          <GoabFormItem>
            <GoabCheckbox
              name="usePersonalEmail"
              text="Use my email address from Alberta.ca Account"
              onChange={({name, value}) => {
                handleETransferChange(name!, value);
                handleBlur("email");
                handleBlur("confirmEmail");
                setTimeout(() => form.validateForm(), 0);
              }}
              checked={fieldValues.usePersonalEmail}
            ></GoabCheckbox>
          </GoabFormItem>
          <GoabFormItem label="Email address" error={fieldErrors.email}>
            <GoabInput
              onChange={({name, value}) => {
                if (fieldValues.usePersonalEmail) {
                  // When using personal email, use the special handler that syncs
                  handleETransferChange(name, value);
                } else {
                  // When manually entering, use regular handler for validation
                  handleChange(name, value);
                }
              }}
              onBlur={() => {
                handleBlur("email");
                handleBlur("confirmEmail");
              }}
              value={fieldValues.email}
              name="email"
              type="email"
              width="37.5ch"
              disabled={fieldValues.usePersonalEmail}
              placeholder="name@email.com"
              error={!!emailError}
            ></GoabInput>
          </GoabFormItem>
          <GoabFormItem
            label="Confirm email address"
            mt="xs"
            error={fieldErrors.confirmEmail}
          >
            <GoabInput
              onChange={({name, value}) => {
                if (fieldValues.usePersonalEmail) {
                  // When using personal email, use the special handler that syncs
                  handleETransferChange(name, value);
                } else {
                  // When manually entering, use regular handler for validation
                  handleChange(name, value);
                }
              }}
              onBlur={() => {
                handleBlur("email");
                handleBlur("confirmEmail");
              }}
              value={fieldValues.confirmEmail}
              name="confirmEmail"
              type="email"
              width="37.5ch"
              disabled={fieldValues.usePersonalEmail}
              placeholder="name@email.com"
              error={!!confirmEmailError}
            ></GoabInput>
          </GoabFormItem>
          <GoabFormItem
            label="Choose how you will receive the e-Transfer:"
            mt="xs"
            mb="m"
          >
            <GoabRadioGroup
              name="receiveETransfer"
              onChange={({name, value}) => {
                handleChange(name, value);
                setTimeout(() => form.validateForm(), 0);
              }}
              orientation="vertical"
              value={fieldValues.receiveETransfer}
            >
              <GoabRadioItem value="email" label="Email address"></GoabRadioItem>
              <GoabRadioItem
                value="mobile"
                label="Mobile phone number"
              ></GoabRadioItem>
              <GoabRadioItem
                value="bankAccount"
                label="Using bank account details"
              ></GoabRadioItem>
            </GoabRadioGroup>
          </GoabFormItem>
          <p>
            If you don't have auto-deposit enabled, you will use your
            application code to accept the e-Transfer payment.
          </p>
          {fieldValues.receiveETransfer === "mobile" && (
            <PhoneNumberETransfer />
          )}

          {fieldValues.receiveETransfer === "bankAccount" && (
            <BankAccountDetailsETransfer />
          )}
        </GoabBlock>
      </GoabContainer>
    </>
  );
};
